import css from "./css";
import greeting from "./greeting";
import message from "./message";
import time from "./time";
import weather from "./weather";

export const widgetConfigs = [
  css,
  greeting,
  message,
  time,
  weather,
];

widgetConfigs.sort((a, b) => a.name.localeCompare(b.name));
